var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerta",class:'alert al ert-dismissible mensagem-' + _vm.type},[_c('div',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-hidden":"true"}},[_vm._v("\n    ×\n  ")]),_vm._v(" "),_c('div',{staticClass:"paragrafo"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }